export default __webpack_public_path__ + "static/media/PANCAKESWAP1.ae1b1226.png";